app.constant('countries', {
    countryCode: [
        {"country": "Afghanistan", "nationality": "Afghan", "code": "AF"},
        {"country": "\u00c5land Islands\u00a0", "nationality": "of the \u00c5land Islands", "code": "AX"},
        {"country": "Albania", "nationality": "Albanian", "code": "AL"},
        {"country": "Algeria", "nationality": "Algerian", "code": "DZ"},
        {"country": "American Samoa\u00a0", "nationality": "American", "code": "AS"},
        {"country": "Andorra", "nationality": "Andorran", "code": "AD"},
        {"country": "Angola", "nationality": "Angolan", "code": "AO"},
        {"country": "Anguilla\u00a0", "nationality": "Anguillan", "code": "AI"},
        {"country": "Antarctica", "nationality": "Antarctic", "code": "AQ"},
        {"country": "Antigua and\u00a0Barbuda", "nationality": "of\u00a0Antigua and\u00a0Barbuda", "code": "AG"},
        {"country": "Argentina", "nationality": "Argentine", "code": "AR"},
        {"country": "Armenia", "nationality": "Armenian", "code": "AM"},
        {"country": "Aruba\u00a0", "nationality": "Aruban", "code": "AW"},
        {"country": "Australia", "nationality": "Australian", "code": "AU"},
        {"country": "Austria", "nationality": "Austrian", "code": "AT"},
        {"country": "Azerbaijan", "nationality": "Azerbaijani", "code": "AZ"},
        {"country": "Bahamas", "nationality": "Bahamian", "code": "BS"},
        {"country": "Bahrain", "nationality": "Bahraini", "code": "BH"},
        {"country": "Bangladesh", "nationality": "Bangladeshi", "code": "BD"},
        {"country": "Barbados", "nationality": "Barbadian", "code": "BB"},
        {"country": "Belarus", "nationality": "Belarusian", "code": "BY"},
        {"country": "Belgium", "nationality": "Belgian", "code": "BE"},
        {"country": "Belize", "nationality": "Belizean", "code": "BZ"},
        {"country": "Benin", "nationality": "Beninese", "code": "BJ"},
        {"country": "Bermuda\u00a0", "nationality": "Bermudian", "code": "BM"},
        {"country": "Bhutan", "nationality": "Bhutanese", "code": "BT"},
        {"country": "Bolivia", "nationality": "Bolivian", "code": "BO"},
        {"country": "Bosnia and Herzegovina", "nationality": "of Bosnia and Herzegovina", "code": "BA"},
        {"country": "Botswana", "nationality": "Botswanan", "code": "BW"},
        {"country": "Bouvet Island\u00a0", "nationality": "of Bouvet Island", "code": "BV"},
        {"country": "Brazil", "nationality": "Brazilian", "code": "BR"},
        {"country": "Brunei", "nationality": "Bruneian", "code": "BN"},
        {"country": "Bulgaria", "nationality": "Bulgarian", "code": "BG"},
        {"country": "Burkina Faso", "nationality": "Burkinabe", "code": "BF"},
        {"country": "Burundi", "nationality": "Burundian", "code": "BI"},
        {"country": "Cambodia", "nationality": "Cambodian", "code": "KH"},
        {"country": "Cameroon", "nationality": "Cameroonian", "code": "CM"},
        {"country": "Canada", "nationality": "Canadian", "code": "CA"},
        {"country": "Cape Verde", "nationality": "Cape Verdean", "code": "CV"},
        {"country": "Cayman Islands\u00a0", "nationality": "Caymanian", "code": "KY"},
        {"country": "Central African Republic", "nationality": "Central African", "code": "CF"},
        {"country": "Chad", "code": "CN", "nationality": "Chadian"},
        {"country": "Chile", "nationality": "Chilean", "code": "TD"},
        {"country": "China", "nationality": "Chinese", "code": "CN"},
        {"country": "Christmas Island\u00a0", "nationality": "of Christmas Island", "code": "CX"},
        {"country": "Cocos ", "nationality": "of the Cocos (Keeling) Islands", "code": "CC"},
        {"country": "Colombia", "nationality": "Colombian", "code": "CO"},
        {"country": "Comoros", "nationality": "Comorian", "code": "KM"},
        {"country": "Congo\u00a0", "nationality": "Congolese", "code": "CG"},
        {"country": "Cook Islands\u00a0", "nationality": "of the Cook Islands", "code": "CK"},
        {"country": "Costa Rica", "nationality": "Costa Rican", "code": "CR"},
        {"country": "C\u00f4te d\u2019Ivoire", "nationality": "Ivorian", "code": "CI"},
        {"country": "Croatia", "nationality": "Croatian", "code": "HR"},
        {"country": "Cuba", "nationality": "Cuban", "code": "CU"},
        {"country": "Cyprus", "nationality": "Cypriot", "code": "CY"},
        {"country": "Czech Republic", "nationality": "Czech", "code": "CZ"},
        {"country": "Denmark", "nationality": "Danish", "code": "DK"},
        {"country": "Djibouti", "nationality": "of Djibouti", "code": "DJ"},
        {"country": "Dominica", "nationality": "of Dominica", "code": "DM"},
        {"country": "Dominican Republic", "nationality": "Dominican", "code": "DO"},
        {"country": "Ecuador", "nationality": "Ecuadorian", "code": "EC"},
        {"country": "Egypt", "nationality": "Egyptian", "code": "EG"},
        {"country": "El Salvador", "nationality": "Salvadorian; Salvadoran", "code": "SV"},
        {"country": "Equatorial Guinea", "nationality": "of Equatorial Guinea", "code": "GQ"},
        {"country": "Eritrea", "nationality": "Eritrean", "code": "ER"},
        {"country": "Estonia", "nationality": "Estonian", "code": "EE"},
        {"country": "Ethiopia", "nationality": "Ethiopian", "code": "ET"},
        {"country": "Faeroe Islands\u00a0", "nationality": "Faeroese", "code": "FO"},
        {"country": "Falkland Islands\u00a0", "nationality": "of the Falkland Islands", "code": "FK"},
        {"country": "Fiji", "nationality": "Fijian", "code": "FJ"},
        {"country": "Finland", "nationality": "Finnish", "code": "FI"},
        {"country": "France", "nationality": "French", "code": "FR"},
        {"country": "French Guiana\u00a0", "nationality": "Guianese", "code": "GF"},
        {"country": "French Polynesia\u00a0", "nationality": "Polynesian", "code": "PF"},
        {"country": "Gabon", "nationality": "Gabonese", "code": "GA"},
        {"country": "Gambia, ", "nationality": "Gambian", "code": "GM"},
        {"country": "Georgia", "nationality": "Georgian", "code": "GE"},
        {"country": "Germany", "nationality": "German", "code": "DE"},
        {"country": "Ghana", "nationality": "Ghanaian", "code": "GH"},
        {"country": "Gibraltar\u00a0", "nationality": "Gibraltarian", "code": "GI"},
        {"country": "Greece", "nationality": "Greek", "code": "GR"},
        {"country": "Greenland\u00a0", "nationality": "Greenlandic", "code": "GL"},
        {"country": "Grenada", "nationality": "Grenadian", "code": "GD"},
        {"country": "Guadeloupe\u00a0", "nationality": "Guadeloupean", "code": "GP"},
        {"country": "Guam\u00a0", "nationality": "Guamanian", "code": "GU"},
        {"country": "Guatemala", "nationality": "Guatemalan", "code": "GT"},
        {"country": "Guernsey\u00a0", "nationality": "Guernsey", "code": "GG"},
        {"country": "Guinea", "nationality": "Guinean", "code": "GN"},
        {"country": "Guinea-Bissau", "nationality": "of Guinea-Bissau", "code": "GW"},
        {"country": "Guyana", "nationality": "Guyanese", "code": "GY"},
        {"country": "Haiti", "nationality": "Haitian", "code": "HT"},
        {"country": "Honduras", "nationality": "Honduran", "code": "HN"},
        {"country": "Hong Kong\u00a0", "nationality": "Hong Kong Chinese", "code": "HK"},
        {"country": "Hungary", "nationality": "Hungarian", "code": "HU"},
        {"country": "Iceland", "nationality": "Icelandic", "code": "IS"},
        {"country": "India", "nationality": "Indian", "code": "IN"},
        {"country": "Indonesia", "nationality": "Indonesian", "code": "ID"},
        {"country": "Iran", "nationality": "Iranian", "code": "IR"},
        {"country": "Iraq", "nationality": "Iraqi", "code": "IQ"},
        {"country": "Ireland", "nationality": "Irish", "code": "IE"},
        {"country": "Isle of Man\u00a0", "nationality": "Manx", "code": "IM"},
        {"country": "Israel", "nationality": "Israeli", "code": "IL"},
        {"country": "Italy", "nationality": "Italian", "code": "IT"},
        {"country": "Jamaica", "nationality": "Jamaican", "code": "JM"},
        {"country": "Japan", "nationality": "Japanese", "code": "JP"},
        {"country": "Jersey\u00a0", "nationality": "Jersey", "code": "JE"},
        {"country": "Jordan", "nationality": "Jordanian", "code": "JO"},
        {"country": "Kazakhstan", "nationality": "Kazakh", "code": "KZ"},
        {"country": "Kenya", "nationality": "Kenyan", "code": "KE"},
        {"country": "Kiribati", "nationality": "Kiribatian", "code": "KI"},
        {"country": "Kuwait", "nationality": "Kuwaiti", "code": "KW"},
        {"country": "Kyrgyzstan", "nationality": "Kyrgyz", "code": "KG"},
        {"country": "Laos", "nationality": "Lao; Laotian", "code": "LA"},
        {"country": "Latvia", "nationality": "Latvian", "code": "LV"},
        {"country": "Lebanon", "nationality": "Lebanese", "code": "LB"},
        {"country": "Lesotho", "nationality": "of Lesotho", "code": "LS"},
        {"country": "Liberia", "nationality": "Liberian", "code": "LR"},
        {"country": "Libya", "nationality": "Libyan", "code": "LY"},
        {"country": "Liechtenstein", "nationality": "of Liechtenstein", "code": "LI"},
        {"country": "Lithuania", "nationality": "Lithuanian", "code": "LT"},
        {"country": "Luxembourg", "nationality": "Luxembourgish", "code": "LU"},
        {"country": "Madagascar", "nationality": "Malagasy", "code": "MG"},
        {"country": "Malawi", "nationality": "Malawian", "code": "MW"},
        {"country": "Malaysia", "nationality": "Malaysian", "code": "MY"},
        {"country": "Maldives", "nationality": "Maldivian", "code": "MV"},
        {"country": "Mali", "nationality": "Malian", "code": "ML"},
        {"country": "Malta", "nationality": "Maltese", "code": "MT"},
        {"country": "Marshall Islands", "nationality": "Marshallese", "code": "MH"},
        {"country": "Martinique\u00a0", "nationality": "Martinican", "code": "MQ"},
        {"country": "Mauritania", "nationality": "Mauritanian", "code": "MR"},
        {"country": "Mauritius", "nationality": "Mauritian", "code": "MU"},
        {"country": "Mayotte\u00a0", "nationality": "Mahoran", "code": "YT"},
        {"country": "Mexico", "nationality": "Mexican", "code": "MX"},
        {"country": "Micronesia", "nationality": "of Micronesia", "code": "FM"},
        {"country": "Moldova", "nationality": "Moldovan", "code": "MD"},
        {"country": "Monaco", "nationality": "Monegasque", "code": "MC"},
        {"country": "Mongolia", "nationality": "Mongolian", "code": "MN"},
        {"country": "Montenegro", "nationality": "Montenegrin", "code": "ME"},
        {"country": "Montserrat\u00a0", "nationality": "Montserratian", "code": "MS"},
        {"country": "Morocco", "nationality": "Moroccan", "code": "MA"},
        {"country": "Mozambique", "nationality": "Mozambican", "code": "MZ"},
        {"country": "Namibia", "nationality": "Namibian", "code": "NA"},
        {"country": "Nauru", "nationality": "Nauruan", "code": "NR"},
        {"country": "Nepal", "nationality": "Nepalese", "code": "NP"},
        {"country": "Netherlands\u00a0", "nationality": "Dutch", "code": "NL"},
        {"country": "New Caledonia\u00a0", "nationality": "New Caledonian", "code": "NC"},
        {"country": "New Zealand", "nationality": "of New Zealand", "code": "NZ"},
        {"country": "Nicaragua", "nationality": "Nicaraguan", "code": "NI"},
        {"country": "Niger", "nationality": "Nigerien", "code": "NE"},
        {"country": "Nigeria", "nationality": "Nigerian", "code": "NG"},
        {"country": "Niue\u00a0", "nationality": "Niuean", "code": "NU"},
        {"country": "Norfolk Island\u00a0", "nationality": "of Norfolk Island", "code": "NF"},
        {"country": "Norway", "nationality": "Norwegian", "code": "NO"},
        {"country": "Oman", "nationality": "Omani", "code": "OM"},
        {"country": "Pakistan", "nationality": "Pakistani", "code": "PK"},
        {"country": "Palau", "nationality": "Palauan", "code": "PW"},
        {"country": "Panama", "nationality": "Panamanian", "code": "PA"},
        {"country": "Paraguay", "nationality": "Paraguayan", "code": "PY"},
        {"country": "Peru", "nationality": "Peruvian", "code": "PE"},
        {"country": "Philippines", "nationality": "Philippine", "code": "PH"},
        {"country": "Pitcairn Islands\u00a0", "nationality": "Pitcairner", "code": "PN"},
        {"country": "Poland", "nationality": "Polish", "code": "PL"},
        {"country": "Portugal", "nationality": "Portuguese", "code": "PT"},
        {"country": "Puerto Rico\u00a0", "nationality": "Puerto Rican", "code": "PR"},
        {"country": "Qatar", "nationality": "Qatari", "code": "QA"},
        {"country": "R\u00e9union\u00a0", "nationality": "Reunionese", "code": "RE"},
        {"country": "Romania", "nationality": "Romanian", "code": "RO"},
        {"country": "Russia", "nationality": "Russian", "code": "RU"},
        {"country": "Rwanda", "nationality": "Rwandan; Rwandese", "code": "RW"},
        {"country": "Saint Barth\u00e9lemy\u00a0", "nationality": "of Saint Barth\u00e9lemy", "code": "BL"},
        {"country": "Saint Lucia", "nationality": "Saint Lucian", "code": "LC"},
        {"country": "Saint Martin\u00a0", "nationality": "of Saint Martin", "code": "MF"},
        {"country": "Samoa", "nationality": "Samoan", "code": "WS"},
        {"country": "San Marino", "nationality": "of San Marino", "code": "SM"},
        {"country": "Saudi Arabia", "nationality": "Saudi Arabian", "code": "SA"},
        {"country": "Senegal", "nationality": "Senegalese", "code": "SN"},
        {"country": "Serbia", "nationality": "Serbian", "code": "RS"},
        {"country": "Seychelles", "nationality": "of Seychelles", "code": "SC"},
        {"country": "Sierra Leone", "nationality": "Sierra Leonean", "code": "SL"},
        {"country": "Singapore", "nationality": "Singaporean", "code": "SG"},
        {"country": "Slovakia", "nationality": "Slovak; Slovakian", "code": "SK"},
        {"country": "Slovenia", "nationality": "Slovenian", "code": "SL"},
        {"country": "Solomon Islands", "nationality": "of the Solomon Islands", "code": "SB"},
        {"country": "Somalia", "nationality": "Somali; Somalian", "code": "SO"},
        {"country": "South Africa", "nationality": "South African", "code": "ZA"},
        {"country": "South Korea", "nationality": "South Korean", "code": "SK"},
        {"country": "South Sudan", "nationality": "South Sudanese", "code": "SS"},
        {"country": "Spain", "nationality": "Spanish", "code": "ES"},
        {"country": "Sri Lanka", "nationality": "Sri Lankan", "code": "LK"},
        {"country": "Sudan", "nationality": "Sudanese", "code": "SD"},
        {"country": "Suriname", "nationality": "Surinamese", "code": "SR"},
        {"country": "Swaziland", "nationality": "Swazi", "code": "CH"},
        {"country": "Sweden", "nationality": "Swedish", "code": "SE"},
        {"country": "Switzerland", "nationality": "Swiss", "code": "CH"},
        {"country": "Syria", "nationality": "Syrian", "code": "SY"},
        {"country": "Taiwan", "nationality": "Taiwanese", "code": "TW"},
        {"country": "Tajikistan", "nationality": "Tajik", "code": "TJ"},
        {"country": "Tanzania", "nationality": "Tanzanian", "code": "TZ"},
        {"country": "Thailand", "nationality": "Thai", "code": "BI"},
        {"country": "Timor-Leste", "nationality": "East Timorese", "code": "TL"},
        {"country": "Togo", "nationality": "Togolese", "code": "TG"},
        {"country": "Tokelau\u00a0", "nationality": "Tokelauan", "code": "TK"},
        {"country": "Tonga", "nationality": "Tongan", "code": "TO"},
        {"country": "Trinidad and Tobago", "nationality": "of Trinidad and\u00a0Tobago", "code": "TT"},
        {"country": "Tunisia", "nationality": "Tunisian", "code": "TN"},
        {"country": "Turkey", "nationality": "Turkish", "code": "TR"},
        {"country": "Turkmenistan", "nationality": "Turkmen", "code": "TM"},
        {"country": "Tuvalu", "nationality": "Tuvaluan", "code": "TV"},
        {"country": "Uganda", "nationality": "Ugandan", "code": "UG"},
        {"country": "Ukraine", "nationality": "Ukrainian", "code": "UA"},
        {"country": "United Arab Emirates", "nationality": "Emirian", "code": "AE"},
        {"country": "United Kingdom", "nationality": "British", "code": "GB"},
        {"country": "United States", "nationality": "American", "code": "US"},
        {"country": "Uruguay", "nationality": "Uruguayan", "code": "UY"},
        {"country": "Uzbekistan", "nationality": "Uzbek", "code": "UZ"},
        {"country": "Vanuatu", "nationality": "Vanuatuan", "code": "VU"},
        {"country": "Venezuela", "nationality": "Venezuelan", "code": "VE"},
        {"country": "Vietnam", "nationality": "Vietnamese", "code": "VN"},
        {"country": "Western Sahara\u00a0", "nationality": "Sahrawi", "code": "EH"},
        {"country": "Yemen", "nationality": "Yemeni", "code": "YE"},
        {"country": "Zambia", "nationality": "Zambian", "code": "ZM"},
        {"country": "Zimbabwe", "nationality": "Zimbabwean", "code": "ZW"}
    ]
});
